module.exports = __webpack_public_path__ + "static/media/cn-english-website.62134a55.md";